import { render, staticRenderFns } from "./day-configurator-body.vue?vue&type=template&id=33f0f7cb&scoped=true&"
import script from "./day-configurator-body.vue?vue&type=script&lang=js&"
export * from "./day-configurator-body.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-body.vue?vue&type=style&index=0&id=33f0f7cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0f7cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f0f7cb')) {
      api.createRecord('33f0f7cb', component.options)
    } else {
      api.reload('33f0f7cb', component.options)
    }
    module.hot.accept("./day-configurator-body.vue?vue&type=template&id=33f0f7cb&scoped=true&", function () {
      api.rerender('33f0f7cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/day-configurator-body.vue"
export default component.exports